export default import.meta.ROLLDOWN_FILE_URL_UxkwKUwOh852RmDazYPIzQ